





















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import ContactLensItemDetailStore from '../store'

import ContactLensPowerRightDropdown from '@ajax/vue/components/organisms/contact-lens/power/RightDropdown.vue'

@Component({
  components: {
    ContactLensPowerRightDropdown,
  },
})
export default class ContactLensPowerRightArea extends Vue {
  @Prop({ required: true })
  id: string

  @Prop({ required: true })
  store: ContactLensItemDetailStore | null

  @Prop({ required: true })
  isLoading: boolean
}
